export type FP = {
  title: string;
  src: string;
};

const FrameProps: FP[] = [
  {
    title: "React Movie App",
    src: "https://whmcquaid.github.io/React-RMDB/",
  },
  {
    title: "Surf App",
    src: "https://github.com/whmcquaid/surf-app",
  },
  {
    title: "Trivia App",
    src: "https://vue-trivia-app-rouge.vercel.app/",
  },
  {
    title: "My Blog",
    src: "https://myblog26211.gatsbyjs.io/",
  },
  {
    title: "React Calculator",
    src: "https://new-calc-seven.vercel.app/",
  },
  {
    title: "Etch a Sketch",
    src: "https://whmcquaid.github.io/etch_a_sketch",
  },
  {
    title: "Library App",
    src: "https://whmcquaid.github.io/library_app",
  },

  {
    title: "Rock Paper Scissors",
    src: "https://whmcquaid.github.io/rock_paper_scissors/",
  },
];
export default FrameProps;
